// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3WYdN","title":"ClientInsurance_title__1BVW3","itemText":"ClientInsurance_itemText__2qbG3"};